import React from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography } from '@material-ui/core';
import { DropzoneArea } from 'material-ui-dropzone'
import Image from 'material-ui-image';
import { capitalize } from "../../sc-utilities";

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: "auto",
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down("sm")]: {
            padding: 0,
            margin: 0,
            width: "100%",
        },
    },
    imgDiv: {
        margin: '0 auto',
        maxWidth: 800,
        maxHeight: 700
    },
    img: {
        width: '100%',
        height: '100%',
        maxWidth: window.innerWidth - 100,
        maxHeight: window.innerHeight - 100
    }
});

const ImageUpload = props => {
    const { classes, translations, edit, imageValue, handleUpload } = props;

    return (
        <div className={classes.root}>
            {edit ? <>
                <div className={classes.imgDiv}>
                    {imageValue === '' || imageValue === undefined ? (
                        <Typography variant={"subtitle2"}>{translations['image_will_be_displayed'] || 'Image will be displayed here'}</Typography>
                    ) : (
                        <Image
                            src={imageValue ? imageValue : ''}
                            aspectRatio={(16 / 9)}
                            disableSpinner
                        />)}
                </div>
            </> : null}

            {edit ? null :
                <div className={classes.img}>
                    <DropzoneArea
                        filesLimit={1}
                        maxFileSize={5368709120}
                        getFileRemovedMessage={(fileName) => {
                            const text = translations ? (
                                capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['removed'] || 'removed'}.`)
                            ) : `File ${fileName} removed.`
    
                            return text;
                        }}
                        getFileAddedMessage={(fileName) => {
                            const text = translations ? (
                                capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['successfully_added'] || 'successfully added'}.`)
                            ) : `File ${fileName} successfully added.`
    
                            return text;
                        }}
                        getFileLimitExceedMessage={(filesLimit) => {
                            const text = translations ? (
                                capitalize(`${translations['maximum_allowed_number'] || 'Maximum allowed number of files exceeded. Only'} ${filesLimit} ${translations['allowed'] || 'allowed'}.`)
                            ) : `Maximum allowed number of files exceeded. Only ${filesLimit} allowed`
    
                            return text;
                        }}
                        getDropRejectMessage={(rejectedFile) => {
                            const text = translations ? (
                                capitalize(`${translations['File'] || 'File'} ${translations['was_rejected'] || 'was rejected'}.`)
                            ) : `File was rejected.`
    
                            return text;
                        }}
                        dropzoneText={translations['drag_and_drop'] || 'Drag and drop an image file here or click'}
                        onChange={handleUpload}
                        acceptedFiles={['image/jpg', 'image/jpeg', 'image/png']}
                    />
                </div>}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state?.translate?.translations?.activeTranslations || {},
    };
};

export default connect(
    mapStateToProps,
    null,
)(withStyles(styles)(ImageUpload));
